module.exports = __webpack_public_path__ + "static/media/SideArrow.f5e59a6d.svg";